var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"font-size":"14px","margin-top":"10px"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.filterString())}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.groupString())}})])}
var staticRenderFns = []

export { render, staticRenderFns }